/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { useRecoilValue } from "recoil";
import { websiteDataState } from "helpers/recoil";

import ReactMarkdown from "react-markdown"

function SectionDark() {
    const websiteData = useRecoilValue(websiteDataState)
    return (
        <>
            <div className="section section-dark" style={{ 
                padding: "80px 0",
                background: "linear-gradient(135deg, #00adee 0%, #0096cc 100%)",
                boxShadow: "0 10px 40px rgba(0, 173, 238, 0.2)"
            }}>
                <Container>
                    <Row>
                        <Col className="ms-auto me-auto text-center" md="10" lg="8">
                            <h2 className="title" style={{ 
                                fontSize: "36px", 
                                fontWeight: "700",
                                color: "#FFFFFF",
                                marginBottom: "32px",
                                textShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                                letterSpacing: "-0.5px",
                                lineHeight: "1.2"
                            }}>{websiteData?.snippetsDictionary?.['section-header-tarieven']?.text||"Tarieven"}</h2>
                            <div style={{ 
                                fontSize: "16px", 
                                lineHeight: "1.7", 
                                color: "#FFFFFF",
                                textAlign: "left",
                                background: "rgba(255, 255, 255, 0.1)",
                                padding: "30px",
                                borderRadius: "12px",
                                backdropFilter: "blur(10px)",
                                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)"
                            }}>
                                <ReactMarkdown>
                                    {websiteData?.snippetsDictionary?.['section-body-tarieven']?.markup.markdown }
                                </ReactMarkdown>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SectionDark;
